export const ACCEPTED_OFFER_HEADER_TITLE =
  'Congratulations! The below is your conditional loan approval subject to review by the lending underwriter';
export const QUILO_FIXED_RATE_DESCRIPTION =
  'The rate expressed assumes you elect for autopay. Loans not set up on autopay (i.e. loans that are invoiced) are subject to a rate that is 0.25% higher than the rate shown.';
export enum LoanOfferIndicatorsText {
  CashToYou = 'Cash to You',
  GrossLoan = 'Gross Loan',
  FixedRate = 'Fixed Rate',
  APR = 'APR',
  TermYears = 'Term (years)',
  MonthlyPayment = 'Monthly Payment',
}
